'use client';

import { c as _c } from "react/compiler-runtime";
import { useWebHaptics } from 'web-haptics/react';
interface ZoomSliderProps {
  zoom: number;
  onZoomChange: (zoom: number) => void;
}
export function ZoomSlider(t0) {
  const $ = _c(26);
  const {
    zoom,
    onZoomChange
  } = t0;
  const haptic = useWebHaptics();
  let t1;
  if ($[0] !== haptic || $[1] !== onZoomChange || $[2] !== zoom) {
    t1 = () => {
      haptic.trigger("light");
      onZoomChange(Math.max(50, zoom - 10));
    };
    $[0] = haptic;
    $[1] = onZoomChange;
    $[2] = zoom;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg className="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 12H4" /></svg>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <button type="button" onClick={t1} className="opacity-40 transition-opacity hover:opacity-100" aria-label="Zoom out">{t2}</button>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onZoomChange) {
    t4 = e => onZoomChange(Number(e.target.value));
    $[7] = onZoomChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4 || $[10] !== zoom) {
    t5 = <div className="relative flex items-center"><input type="range" min="50" max="200" step="10" value={zoom} onChange={t4} className="h-1 w-24 cursor-pointer appearance-none rounded-lg bg-zinc-200 dark:bg-zinc-800 [&::-moz-range-thumb]:h-3 [&::-moz-range-thumb]:w-3 [&::-moz-range-thumb]:cursor-pointer [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:bg-current [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-current" aria-label="Zoom level" /></div>;
    $[9] = t4;
    $[10] = zoom;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== haptic || $[13] !== onZoomChange || $[14] !== zoom) {
    t6 = () => {
      haptic.trigger("light");
      onZoomChange(Math.min(200, zoom + 10));
    };
    $[12] = haptic;
    $[13] = onZoomChange;
    $[14] = zoom;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg className="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4v16m8-8H4" /></svg>;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6) {
    t8 = <button type="button" onClick={t6} className="opacity-40 transition-opacity hover:opacity-100" aria-label="Zoom in">{t7}</button>;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== zoom) {
    t9 = <span className="ml-2 text-xs opacity-40">{zoom}%</span>;
    $[19] = zoom;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t5 || $[23] !== t8 || $[24] !== t9) {
    t10 = <div className="flex items-center gap-3">{t3}{t5}{t8}{t9}</div>;
    $[21] = t3;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}